import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";
import rsaController from "../utils/RSA-controller";
import { fetchAndStoreServerPublicKey } from "../utils/apiClient";

const SplashScreen = ({ onReady }) => {
  const [message, setMessage] = useState("");

  const MIN_DISPLAY_TIME_MS = 100; // 5 seconds

  useEffect(() => {
    let cancelled = false;
    const startTime = Date.now();

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const ensureMinDisplayTime = async () => {
      const elapsed = Date.now() - startTime;
      if (elapsed < MIN_DISPLAY_TIME_MS) {
        await delay(MIN_DISPLAY_TIME_MS - elapsed);
      }
    };

    const initialize = async () => {
      while (!cancelled) {
        if (typeof navigator !== "undefined" && !navigator.onLine) {
          setMessage("No internet connection. Waiting to reconnect...");
          await delay(3000);
          continue;
        }

        try {
          setMessage("");

          // Ensure local RSA keypair exists (required for encryption)
          await rsaController.getUserPublicKey();

          // Fetch server public key, but do NOT block app startup if it fails.
          // We log the error and allow the main app to load; subsequent
          // encrypted calls can handle missing server key as needed.
          try {
            await fetchAndStoreServerPublicKey();
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error(
              "Failed to fetch or store server public key during splash initialization. Continuing without it.",
              e
            );
          }

          await ensureMinDisplayTime();

          if (!cancelled && typeof onReady === "function") {
            onReady();
          }
          return;
        } catch (error) {
          // Keep user on splash and retry on real failures (e.g. crypto APIs)
          // but avoid tight loops.
          // eslint-disable-next-line no-console
          console.error("Error during splash initialization. Retrying...", error);
          setMessage("Connection problem. Retrying...");
          await delay(3000);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, [onReady]);

  return (
    <div className="splash-screen">
      <div className="splash-content">
        <img src={logo} alt="MFG Invest" className="splash-logo" />
        {message && (
          <p className="splash-message">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default SplashScreen;

